import { create } from 'zustand';

import {
  defaultWeeklyLogAverageTotal,
  defaultWeeklyParams,
  filtersWeeklyLogsDefault,
  FiltersWeeklyLogsInterface,
  FormWeeklyLogInterface,
  WeeklyLogAveragesTotalRespInterface,
  WeeklyLogReqParams,
  WeeklyLogResponse,
} from '../../pages/WeeklyLog/WeeklyLogModel';

interface LogStore {
  filtersValuesDefault: FiltersWeeklyLogsInterface;
  filtersValuesChange: FiltersWeeklyLogsInterface;

  weeklyLogFetchResponse: WeeklyLogResponse[];
  updateWeeklyLogFetchResponse: (values: WeeklyLogResponse[]) => void;

  weeklyLogAverageTotalResponse: {
    totals: WeeklyLogAveragesTotalRespInterface;
    avg: WeeklyLogAveragesTotalRespInterface;
  };

  updateWeeklyLogAvgTotalResponse: (
    totalValues: WeeklyLogAveragesTotalRespInterface,
    avgValues: WeeklyLogAveragesTotalRespInterface,
  ) => void;

  loading: boolean;
  updateLoading: (value: boolean) => void;

  loadingSave: boolean;
  updateLoadingSave: (value: boolean) => void;

  updateFiltersChange: (obj: Partial<FiltersWeeklyLogsInterface>) => void;
  updateFiltersDefault: (obj: FiltersWeeklyLogsInterface) => void;

  formWeeklyLog: FormWeeklyLogInterface[];
  updateFormWeeklyLog: (
    index: number,
    obj: Partial<FormWeeklyLogInterface>,
  ) => void;

  weeklyReqParams: WeeklyLogReqParams;
  updateWeeklyParams: (obj: Partial<WeeklyLogReqParams>) => void;
}

const useWeeklyLogStore = create<LogStore>((set, get) => ({
  loading: false,
  updateLoading: value => set({ loading: value }),

  weeklyLogAverageTotalResponse: {
    totals: defaultWeeklyLogAverageTotal,
    avg: defaultWeeklyLogAverageTotal,
  },
  updateWeeklyLogAvgTotalResponse: (totalValues, avgValues) =>
    set({
      weeklyLogAverageTotalResponse: { totals: totalValues, avg: avgValues },
    }),

  weeklyReqParams: defaultWeeklyParams,
  updateWeeklyParams: obj => {
    set(state => ({
      weeklyReqParams: { ...state.weeklyReqParams, ...obj },
    }));
  },

  loadingSave: false,
  updateLoadingSave: value => set({ loadingSave: value }),

  filtersValuesDefault: filtersWeeklyLogsDefault,
  filtersValuesChange: filtersWeeklyLogsDefault,

  weeklyLogFetchResponse: [],
  updateWeeklyLogFetchResponse: (values: WeeklyLogResponse[]) => {
    let objForm: FormWeeklyLogInterface[] = [];

    if (values.length > 0) {
      const newArr: FormWeeklyLogInterface[] = values.map(item => {
        return {
          id: item.id,
          follow_ups: item.follow_ups,
          responses_sent: item.responses_sent,
          out_of_office: item.out_of_office,
          notes: item.notes,
        };
      });
      objForm = [...newArr];
    }

    set({
      weeklyLogFetchResponse: values,
      loading: false,
      formWeeklyLog: objForm,
    });
  },

  updateFiltersChange: obj => {
    set(state => ({
      filtersValuesChange: { ...state.filtersValuesChange, ...obj },
    }));
  },

  updateFiltersDefault: obj => set({ filtersValuesDefault: obj }),

  formWeeklyLog: [],

  updateFormWeeklyLog: (index, obj) =>
    set(state => ({
      formWeeklyLog: state.formWeeklyLog.map((c, i) =>
        i === index ? { ...c, ...obj } : c,
      ),
    })),
}));

export default useWeeklyLogStore;
